import { render } from "./TableHeader.vue?vue&type=template&id=27bbe649&scoped=true"
import script from "./TableHeader.vue?vue&type=script&lang=js"
export * from "./TableHeader.vue?vue&type=script&lang=js"

import "./TableHeader.vue?vue&type=style&index=0&id=27bbe649&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27bbe649"]])

export default __exports__